import {gql, useQuery} from "@apollo/client";
export const  PRODUCT_DETAIL = gql`
query ProductDetail($contentItemId: ID) {
    product(where: {contentItemId: $contentItemId, localization: {culture_starts_with: "fa"}}) {
      contentItemId
    displayText
    productAdvantageList {
      contentItems {
        ... on ProductAdvantage {
          createdUtc
          displayText
          htmlBody {
            html
          }
          productId {
            contentItems {
              ... on Product {
                contentItemId
              }
            }
          }
        }
        ... on LabelForAdvantage {
          displayText
        }
      }
    }
    productImageList {
      contentItems {
        ... on ProductImage {
          displayText
          productImage {
            urls(first: 1)
          }
        }
      }
    }
    productCatalogList {
      contentItems {
        ... on ProductCatalog {
          createdUtc
          displayText
          catalogFile {
            urls(first: 1)
          }
          catalogPreview {
            urls(first: 1)
          }
        }
        ... on LabelForCatalog {          
          displayText
        }
      }
    }
    productDrawingList {
      contentItems {
        ... on ProductDrawing {
          displayText
          drawingMedia {
            urls(first: 1)
          }
        }
        ... on LabelForDrawing {
          displayText
        }
      }
    }
    productPickedComplementaryInfoList {
      contentItems {
        ... on ProductComplementaryInfo {
          complementaryInfoValue
          complementaryInfo {
            contentItems {
              ... on ComplementaryInfo {
                id
                displayText
                contentItemId
                parentComplementaryInfo {
                  contentItems {
                    ... on ComplementaryInfo {
                      id
                      displayText
                      userTitle
                    }
                  }
                }
                userTitle
              }
            }
          }
          displayText
        }
        ... on LabelForTechnicalInfo {
          displayText
          labelValue
        }
      }
    }
  }
}

  `;


  export const useProductDetail = (contentItemId) => {
      const {error, loading, data} = useQuery(PRODUCT_DETAIL, {
        variables: { contentItemId: contentItemId }
      });
      
      return {
        error, data, loading
      };
      } 
  